<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>提现管理</h1>
        <p>先开票再打款。结算单确认并经总部复核后，在这里申请提现并上传发票凭证。卡券页不能提现。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="open = true">申请提现</button>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">待开票</div><div class="v">¥ {{ yuan(sum('PENDING_INVOICE')) }}</div><div class="s">{{ count('PENDING_INVOICE') }} 笔</div></div>
      <div class="ch-metric"><div class="k">待核验 / 待打款</div><div class="v">¥ {{ yuan(sum('INVOICED') + sum('VERIFIED')) }}</div><div class="s">已上传发票，等总部处理</div></div>
      <div class="ch-metric"><div class="k">已打款</div><div class="v">¥ {{ yuan(sum('PAID')) }}</div><div class="s">{{ count('PAID') }} 笔</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-steps"><i>1 申请</i><i>2 待开票</i><i>3 已上传凭证</i><i>4 财务核验</i><i>5 打款</i><i>6 完成</i></div>
      <table class="ch-table">
        <thead><tr><th>提交时间</th><th>提现金额</th><th>发票凭证</th><th>状态</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.createdAt }}</td>
            <td>¥ {{ yuan(row.amount) }}</td>
            <td>{{ row.invoiceUrl || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 'PAID' ? 'ok' : 'warn'">{{ statusName(row.status) }}</span></td>
            <td><button v-if="row.status === 'PENDING_INVOICE'" class="ch-link" type="button" @click="invoice(row)">上传发票</button><span v-else>—</span></td>
          </tr>
          <tr v-if="!list.length"><td colspan="5" class="ch-empty">还没有提现记录</td></tr>
        </tbody>
      </table>
    </div>
    <el-dialog title="申请提现" :visible.sync="open" width="420px">
      <el-form label-width="90px" size="small">
        <el-form-item label="提现金额"><el-input v-model="amount" /></el-form-item>
      </el-form>
      <p class="ch-note">提交后状态为待开票。请按总部要求开具发票，再回到列表上传凭证地址。</p>
      <div slot="footer">
        <el-button size="small" @click="open = false">取消</el-button>
        <el-button size="small" type="primary" @click="create">提交申请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelWithdrawals, saveChannelWithdrawal } from '@/api/admin'
import { statusName, yuan } from './labels'

export default {
  name: 'PartnerWithdraw',
  data() { return { list: [], amount: '', open: false } },
  created() { this.load() },
  methods: {
    statusName, yuan,
    sum(status) { return this.list.filter(item => item.status === status).reduce((n, item) => n + Number(item.amount || 0), 0) },
    count(status) { return this.list.filter(item => item.status === status).length },
    async load() {
      const result = await getChannelWithdrawals()
      this.list = result.list || []
    },
    async create() {
      await saveChannelWithdrawal({ amount: this.amount })
      this.amount = ''
      this.open = false
      this.$message.success('已提交，请上传发票')
      this.load()
    },
    async invoice(row) {
      const input = await this.$prompt('发票凭证地址', '上传发票')
      await saveChannelWithdrawal({ action: 'invoice', id: row.id, invoiceUrl: input.value })
      this.$message.success('已提交，等待总部打款')
      this.load()
    }
  }
}
</script>
